import { GifOverlayProps } from '@giphy/react-components'
import React, { useRef } from 'react'
import styled from 'styled-components'
import Attribution_ from './attribution'
const Background = styled.div`
    background: linear-gradient(rgba(0, 0, 0, 0), rgba(18, 18, 18, 0.6));
    cursor: default;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 75px;
    pointer-events: none;
`

const Attribution = styled(Attribution_)`
    position: absolute;
    bottom: 6px;
    left: 6px;
    right: 6px;
`

const Container = styled.div`
    transition: opacity 150ms ease-in;
`

const AttributionOverlay = ({ gif, isHovered }: GifOverlayProps) => {
    const hasHovered = useRef(isHovered)
    if (isHovered) {
        // not rendering to avoid loading the avatar until hover
        hasHovered.current = true
    }
    return gif.user && hasHovered.current ? (
        <Container style={{ opacity: isHovered ? 1 : 0 }}>
            <Background />
            <Attribution gif={gif} />
        </Container>
    ) : null
}

export default AttributionOverlay
